import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '@/lib/cn'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
}

/** Painel branco padrão do layout: canto 6px, sombra fina, sem borda. */
export function Card({ className, children, ...props }: CardProps) {
  return (
    <div className={cn('rounded-card bg-surface shadow-card', className)} {...props}>
      {children}
    </div>
  )
}

interface CardHeaderProps {
  title: ReactNode
  /** Link discreto à direita do título ("Ver lista completa"). */
  action?: ReactNode
  className?: string
}

export function CardHeader({ title, action, className }: CardHeaderProps) {
  return (
    <div className={cn('flex flex-wrap items-baseline gap-x-4 gap-y-1', className)}>
      <h2 className="text-[15px] font-semibold text-ink lg:text-[17px]">{title}</h2>
      {action}
    </div>
  )
}
